import { ApiService } from "./ApiService";
import { ClientDto } from "@shared/types/ClientDto";
import { GetClientProjectsResponse } from "@shared/types/payloads/GetClientProjectsResponse";

export class ClientService {
  constructor(private readonly apiService: ApiService) {}

  async getClientInfo(): Promise<ClientDto> {
    return this.apiService.request<ClientDto>("/client/info", {
      method: "GET",
      requireAuth: true,
    });
  }
  async getClientProjects(): Promise<GetClientProjectsResponse[]> {
    return this.apiService.request<GetClientProjectsResponse[]>(
      "/client/projects",
      {
        method: "GET",
        requireAuth: true,
      }
    );
  }
  async getContractUrl(
    serviceOrderId: string,
    contractType: "msa" | "sow"
  ): Promise<string> {
    const response = await this.apiService.request<{ url: string }>(
      `/contracts/${contractType}?serviceOrderId=${serviceOrderId}`,
      {
        method: "GET",
        requireAuth: true,
      }
    );
    return response.url;
  }
}
